import MainLayout from "@/components/Layout/MainLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Privacy = () => {
  return (
    <MainLayout title="Privacy Policy">
      <div className="container max-w-4xl py-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
          <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>1. Information We Collect</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <h3 className="font-semibold mb-2">Personal Information</h3>
              <ul className="list-disc pl-6 space-y-1 text-sm">
                <li>Name, email address, and contact details</li>
                <li>Client number and account information</li>
                <li>Billing and payment information</li>
                <li>Address and apartment information</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Usage Data</h3>
              <ul className="list-disc pl-6 space-y-1 text-sm">
                <li>Energy consumption patterns</li>
                <li>Smart device usage and control data</li>
                <li>Temperature and humidity sensor readings</li>
                <li>Login history (IP addresses, user agents, timestamps)</li>
              </ul>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>2. How We Use Your Information</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li>Provide and maintain our energy management services</li>
              <li>Process payments and generate bills</li>
              <li>Monitor and control smart devices</li>
              <li>Send notifications about your account and service updates</li>
              <li>Improve our services and develop new features</li>
              <li>Comply with legal obligations</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>3. Data Retention</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm">
            <p>We retain your personal data for as long as necessary to provide our services:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Login history: 90 days</li>
              <li>Security audit logs: 1 year</li>
              <li>Bills and payment records: 7 years (legal requirement)</li>
              <li>Energy consumption data: Duration of active account + 1 year</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>4. Your Rights (GDPR)</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Right to Access:</strong> Request a copy of your personal data</li>
              <li><strong>Right to Rectification:</strong> Request correction of inaccurate data</li>
              <li><strong>Right to Erasure:</strong> Request deletion of your data</li>
              <li><strong>Right to Data Portability:</strong> Export your data in a machine-readable format</li>
              <li><strong>Right to Object:</strong> Object to processing of your data</li>
              <li><strong>Right to Restrict Processing:</strong> Request limitation of data processing</li>
            </ul>
            <p className="mt-4 text-sm">To exercise these rights, go to Settings → Privacy & Data or contact support.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>5. Data Security</CardTitle>
          </CardHeader>
          <CardContent className="text-sm space-y-2">
            <p>We implement appropriate security measures to protect your data:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>End-to-end encryption for sensitive data</li>
              <li>Row-level security policies on all database tables</li>
              <li>Regular security audits and monitoring</li>
              <li>Secure authentication with session management</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>6. Cookies and Tracking</CardTitle>
          </CardHeader>
          <CardContent className="text-sm space-y-2">
            <p>We use essential cookies for:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Authentication and session management</li>
              <li>User preferences (theme, language)</li>
              <li>Security and fraud prevention</li>
            </ul>
            <p className="mt-4">You can manage cookie preferences in Settings → Privacy & Data.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>7. Data Sharing</CardTitle>
          </CardHeader>
          <CardContent className="text-sm">
            <p className="mb-2">We do not sell your personal data. We may share data with:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Payment processors (for billing)</li>
              <li>Cloud infrastructure providers (Supabase)</li>
              <li>Legal authorities (when required by law)</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>8. Contact Us</CardTitle>
          </CardHeader>
          <CardContent className="text-sm">
            <p>For privacy-related questions or to exercise your rights:</p>
            <p className="mt-2">Email: privacy@growthenergyapp.com</p>
            <p>Or visit Settings → Privacy & Data in your account</p>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default Privacy;
